export default "__VITE_ASSET__B7frKG0t__"